import config from '@/config'
import * as Sentry from '@sentry/react-native'
import { nativeBuildVersion } from 'expo-application'
import Constants from 'expo-constants'
import { Platform } from 'react-native'

/**
 * Examples:
 * - `dev`
 * - `1.57.0`
 */
const release =
	config.SENTRY_ENVIRONMENT === 'development' ? 'dev' : Constants.expoConfig?.version

/**
 * Examples:
 * - `web.dev`
 * - `ios.dev`
 * - `android.dev`
 * - `web.1.57.0`
 * - `ios.1.57.0.3`
 * - `android.1.57.0.46`
 */
const dist = `${Platform.OS}.${release}${
	nativeBuildVersion ? `.${nativeBuildVersion}` : ''
}`

export const initSentry = ({
	integrations = [],
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
}: { integrations: any[] }) => {
	Sentry.init({
		autoSessionTracking: false,
		dsn: 'https://5910092add032c8fce32334bcb9c4aff@o4504599944364032.ingest.us.sentry.io/4506904044306432',
		debug: false,
		environment: config.SENTRY_ENVIRONMENT ?? 'development',
		dist,
		release,
		integrations,
	})
}
